/*
 * File: form-string.ts
 * File Created: 2024-01-11 01:28:50
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-21 05:53:59
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { UITag } from "@root/core/tags";
import FormUnitNumber from "../../elements/form-unit-number/form-unit-number";
import InputUnitNumber from "@root/components/inputs/input-unit-number/input-unit-number";

@Component
@UITag.setDefault({
    uiBlockAutofill: true,
    uiDescription: (o, element) => {
        return element?.$refs?.input?.description ?? null;
    },
    uiAttrs: {
        options: [
            {
                label: "w_SquareMeter",
            },
            {
                label: "w_Tsubo",
                ratio: 0.3025,
            },
        ],
    },
})
export default class FormSquareMeter extends FormUnitNumber {}
